import { environment } from '@environments/environment';

export const GET_BLOG_CATEGORIES_QUERY = (langcode: string) => ({
  query: '_search',
  index: environment.integrations?.fournierWebservice?.index_blog ?? '',
  body: {
    size: 10000,
    query: {
      bool: {
        filter: [
          {
            term: {
              search_api_datasource: 'entity:taxonomy_term',
            },
          },
          {
            term: {
              vocabulary: 'categorie_blog',
            },
          },
          {
            term: {
              search_api_language: langcode,
            },
          },
        ],
        must: [
          {
            exists: {
              field: 'parent_term_name',
            },
          },
        ],
        must_not: [
          {
            term: {
              parent_term_name: '',
            },
          },
        ],
      },
    },
    _source: ['term_name', 'parent_term_name', 'url'],
  },
});
